import styled from 'styled-components';

export const GltfLoadingStyled = styled.div`
  display: inline-block;
  ${props =>
    props.isLayoutCentered &&
    `
    width: ${props.canvasWidth || `100%`};
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: ${props.aboveEverything ? `2147483647` : `0`};
  `}
`;

export const TextStyled = styled.small`
  display: block;
  font-size: ${props => props.theme.font.size.default};
  margin: ${props => props.theme.spacing.small};
  max-width: 50vw;
  text-align: center;
  color: ${props => props.theme.color.greyDark};
`;
